export const FETCH_PROGRAMACAO_DIARIAS = 'FETCH_PROGRAMACAO_DIARIAS';
export const FETCH_PROGRAMACAO_DIARIAS_SUCCESS = 'FETCH_PROGRAMACAO_DIARIAS_SUCCESS';

export const DELETE_PROGRAMACAO_DIARIA = 'DELETE_PROGRAMACAO_DIARIA';
export const DELETE_PROGRAMACAO_DIARIA_SUCCESS = 'DELETE_PROGRAMACAO_DIARIA_SUCCESS';

export const SAVE_PROGRAMACAO_DIARIA = 'SAVE_PROGRAMACAO_DIARIA';
export const SAVE_PROGRAMACAO_DIARIA_SUCCESS = 'SAVE_PROGRAMACAO_DIARIA_SUCCESS';

export const UPDATE_PROGRAMACAO_DIARIA = 'UPDATE_PROGRAMACAO_DIARIA';
export const UPDATE_PROGRAMACAO_DIARIA_SUCCESS = 'UPDATE_PROGRAMACAO_DIARIA_SUCCESS';

export const CLEAR_PROGRAMACAO_DIARIA = 'CLEAR_PROGRAMACAO_DIARIA';

export const PROGRAMACAO_DIARIA_FIND_BY_ID = 'PROGRAMACAO_DIARIA_FIND_BY_ID';
export const PROGRAMACAO_DIARIA_FIND_BY_ID_SUCCESS = 'PROGRAMACAO_DIARIA_FIND_BY_ID_SUCCESS';

export const PROGRAMACAO_DIARIA_FIND_OPTIONS = 'PROGRAMACAO_DIARIA_FIND_OPTIONS';
export const PROGRAMACAO_DIARIA_FIND_OPTIONS_SUCCESS = 'PROGRAMACAO_DIARIA_FIND_OPTIONS_SUCCESS';

export const PROGRAMACAO_DIARIA_VALIDATE_BY_ID = 'PROGRAMACAO_DIARIA_VALIDATE_BY_ID';
export const PROGRAMACAO_DIARIA_VALIDATE_BY_ID_SUCCESS = 'PROGRAMACAO_DIARIA_VALIDATE_BY_ID_SUCCESS';

export const PROGRAMACAO_DIARIA_EXPORT = 'PROGRAMACAO_DIARIA_EXPORT';
